import { FailCircleIcon } from '../icons/general.tsx'
import { Alert, AlertDescription, AlertTitle } from '@/shad/ui/alert'

interface AuthorizationErrorProps {
  title?: string
  description?: string
}

const AuthorizationError = ({
  title = 'Access Denied',
  description = 'You do not have the required permissions to access this feature. Please contact your administrator if you believe this is an error.',
}: AuthorizationErrorProps) => {
  return (
    <Alert variant="destructive" className="border-red-200 bg-red-50">
      <FailCircleIcon className="h-4 w-4" />
      <AlertTitle className="text-red-800">{title}</AlertTitle>
      <AlertDescription className="text-red-700">
        {description}
      </AlertDescription>
    </Alert>
  )
}

export { AuthorizationError }
